module.exports = __webpack_public_path__ + "media/images/marketing-banner/installation-1-mob-e952713998e67f8f6c03dbf75bf24ca6.png";